import MicroModal from "micromodal"
import Modal from '../../../../common/modal/Modal'
import Button from '../../../../common/button/Button'
import Icons from '../../../../common/icons/Icons'
import { HandleShowCloseModal } from '../../../../common/modal/HandleShowCloseModal'
import { useCourseReport } from '../../ReportingGroup/context/CourseReportContext'
import UserQuizStats from './content/UserQuizStats'
import QuizDetails from '../../ReportingGroup/UserProgress/Quiz/QuizDetails'
import { useUserReport } from '../../ReportingGroup/context/UserReportContext'

const UserQuiz = ({ from = 'course-report' }) => {
    MicroModal.init()

    const { selectedQuiz } = from === 'course-report' ? useCourseReport() : useUserReport()

    const handleBackToCourse = () => {
        HandleShowCloseModal( 'msync-report-user-container', 'msync-report-user-view-quiz' )
    }

    return (
        <Modal 
            modalId={`msync-report-user-view-quiz`} 
            buttonTitle={''} 
            showModalHeader={ false }
            classNames={''} 
            containerClassNames={'msync-report-user-container'}
        >
            <header className="msync-modal__header">
                <div className="msync-modal__header__title">
                    <Button 
                        onClick={ handleBackToCourse }
                    >
                        <Icons type="arrow-tail-left" />
                        <span className="msync-visually-hidden">Back</span>
                    </Button>
                    <h2 className="msync-modal__header__title__text msync-modal__title">{selectedQuiz.quizName ?? ''}</h2>
                </div>
                <Button 
                  className="msync-modal__close" 
                  aria-label="Close modal" 
                  onClick={()=>MicroModal.close(`msync-report-user-view-quiz`)}
                >
                  <Icons type='close' />
                  <span className="msync-visually-hidden">Close <kbd>ESC</kbd></span>
                </Button>
            </header>
            <main className="msync-modal__body msync-modal__body--has-table msync-reporting__detail" >
                { selectedQuiz && (
                    <>
                        <UserQuizStats from={from}  />
                        <QuizDetails from={from} />
                    </>
                 ) }
            </main>
        </Modal>
    )
}

export default UserQuiz